module.exports = __webpack_public_path__ + "images/nkbv35d6e7a5c40450af75e95f5cf041fd3a.png";